"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(fn, ms) {
  if (!ms) {
    return fn;
  }

  var last = 0;
  var timeout = null;
  return function () {
    var _arguments = arguments;
    var now = Date.now();

    if (now - last > ms) {
      fn.apply(null, arguments);
      last = now;
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(null, _arguments);
        last = Date.now();
      }, Math.max(0, ms - now + last));
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWJvdW5jZS5qcyJdLCJuYW1lcyI6WyJmbiIsIm1zIiwibGFzdCIsInRpbWVvdXQiLCJub3ciLCJEYXRlIiwiYXBwbHkiLCJhcmd1bWVudHMiLCJjbGVhclRpbWVvdXQiLCJzZXRUaW1lb3V0IiwiTWF0aCIsIm1heCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLGtCQUFVQSxFQUFWLEVBQWNDLEVBQWQsRUFBa0I7QUFDL0IsTUFBSSxDQUFDQSxFQUFMLEVBQVM7QUFDUCxXQUFPRCxFQUFQO0FBQ0Q7O0FBRUQsTUFBSUUsSUFBSSxHQUFHLENBQVg7QUFDQSxNQUFJQyxPQUFPLEdBQUcsSUFBZDtBQUVBLFNBQU8sWUFBWTtBQUFBO0FBQ2pCLFFBQU1DLEdBQUcsR0FBR0MsSUFBSSxDQUFDRCxHQUFMLEVBQVo7O0FBRUEsUUFBSUEsR0FBRyxHQUFHRixJQUFOLEdBQWFELEVBQWpCLEVBQXFCO0FBQ25CRCxNQUFBQSxFQUFFLENBQUNNLEtBQUgsQ0FBUyxJQUFULEVBQWVDLFNBQWY7QUFDQUwsTUFBQUEsSUFBSSxHQUFHRSxHQUFQO0FBQ0QsS0FIRCxNQUdPO0FBQ0xJLE1BQUFBLFlBQVksQ0FBQ0wsT0FBRCxDQUFaO0FBRUFBLE1BQUFBLE9BQU8sR0FBR00sVUFBVSxDQUFDLFlBQU07QUFDekJULFFBQUFBLEVBQUUsQ0FBQ00sS0FBSCxDQUFTLElBQVQsRUFBZUMsVUFBZjtBQUNBTCxRQUFBQSxJQUFJLEdBQUdHLElBQUksQ0FBQ0QsR0FBTCxFQUFQO0FBQ0QsT0FIbUIsRUFHakJNLElBQUksQ0FBQ0MsR0FBTCxDQUFTLENBQVQsRUFBWVYsRUFBRSxHQUFHRyxHQUFMLEdBQVdGLElBQXZCLENBSGlCLENBQXBCO0FBSUQ7QUFDRixHQWREO0FBZUQiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiAoZm4sIG1zKSB7XG4gIGlmICghbXMpIHtcbiAgICByZXR1cm4gZm47XG4gIH1cblxuICBsZXQgbGFzdCA9IDA7XG4gIGxldCB0aW1lb3V0ID0gbnVsbDtcblxuICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgIGNvbnN0IG5vdyA9IERhdGUubm93KCk7XG5cbiAgICBpZiAobm93IC0gbGFzdCA+IG1zKSB7XG4gICAgICBmbi5hcHBseShudWxsLCBhcmd1bWVudHMpO1xuICAgICAgbGFzdCA9IG5vdztcbiAgICB9IGVsc2Uge1xuICAgICAgY2xlYXJUaW1lb3V0KHRpbWVvdXQpO1xuXG4gICAgICB0aW1lb3V0ID0gc2V0VGltZW91dCgoKSA9PiB7XG4gICAgICAgIGZuLmFwcGx5KG51bGwsIGFyZ3VtZW50cyk7XG4gICAgICAgIGxhc3QgPSBEYXRlLm5vdygpO1xuICAgICAgfSwgTWF0aC5tYXgoMCwgbXMgLSBub3cgKyBsYXN0KSk7XG4gICAgfVxuICB9O1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/react-scroll-to-bottom/lib/debounce.js
// module id = 150
// module chunks = 0